import { Loader } from '@components/loader';
import { useGetApiKey } from '@services/staff/acquirer/apiKeys/get';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { ApiKeyShow } from '@pages/apiKeys/id';
import { useDisableApiKey } from '@services/staff/acquirer/apiKeys/disable';
import { useGetPermissionGroups } from '@services/acquirer/apiKeys/permissionGroups';

const ShowApiKey = () => {
  const { id, acquirerId, localId } = useParams({
    from: '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/',
  });
  const navigate = useNavigate();
  const { data, isPending } = useGetApiKey({ id, acquirerId });
  const { mutate, isPending: disabling } = useDisableApiKey(acquirerId);
  const { data: permissions } = useGetPermissionGroups();

  if (isPending) return <Loader />;

  return (
    <ApiKeyShow
      apiKey={data}
      onDisable={mutate}
      disabling={disabling}
      permissions={permissions}
      handleDuplicateRedirect={() => {
        navigate({
          to: '/u/$localId/staff/acquirers/$acquirerId/api-keys/new',
          params: { acquirerId, localId },
          search: { duplicateFrom: data.id },
        }).catch((err) => console.error(err));
      }}
    />
  );
};

export const Route = createFileRoute(
  '/u/$localId/_staff/staff/acquirers/$acquirerId/api-keys/$id/',
)({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['api_keys_read'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: ShowApiKey,
});
